import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/shared/utils/cn";

export interface FieldGroupProps extends ComponentProps<"fieldset"> {
  legend?: ReactNode;
}

export function FieldGroup({ legend, className, children, ...props }: FieldGroupProps) {
  return (
    <fieldset className={cn("min-w-0 space-y-[18px] rounded-[20px] border border-border bg-card p-4 sm:p-5", className)} {...props}>
      {legend && <legend className="px-1 text-[21px] font-bold">{legend}</legend>}
      {children}
    </fieldset>
  );
}
